<div class="dunning-action-form" [class.block-loader]="canBeCompletedLoader.isLoading$ | async">

	<dunning-action-form-header 
		[shouldDisplayWarningOfNoContact]="!contactsAreOptional && (shouldDisplayWarningOfNoContact$ | async)"
		[currentActionTypeIsImmutable]="currentActionTypeIsImmutable$ | async"
		[canBeCompleted]="canBeCompletedDelayed$ | async"
		[isRealized]="isRealized"
	/>

	@if (currentAction$ | async; as action) {
		<form [formGroup]="form">

			<div class="d-flex flex-column">
				@if (action.someAccountingDocumentsDropped) {
					<dunning-action-some-documents-dropped />
				}

				<div class="row">
					<dunning-action-form-field-type  [field]="typeField" />
					<dunning-action-form-field-level [field]="dunningLevelField" [muted]="(dunningLevelField?.valueChanges | async) === null" />


					@for (attribute of actionTypeSpec?.attributes; track attribute.uuid) {
						@if (attribute.type === DAAType.Separator) { <div class="col-md-4"></div> }
						
						@if (attribute.type === DAAType.TemplatePlaceholder) {
							<dunning-action-form-field-template-placeholder [attribute]="attribute" />
						}

						@if (!!attribute.type && form.get(attribute.field)) {
							@switch (attribute.type) {
								@case (DAAType.SubOrigin) {
									<dunning-action-form-field-suborigin [attribute]="attribute" />
								}
								@case (DAAType.SubType) {
									<dunning-action-form-field-subtype [attribute]="attribute" />
								}
								@case (DAAType.Template) {
									<dunning-action-form-field-template [attribute]="attribute" />
								}
								@case (DAAType.DueDate) {
									<dunning-action-form-field-due-date
										[initialDueDate]="initialDueDate"
										[dueDateMinDate]="dueDateMinDate"
										[disabledDates]="disabledDates"
										[attribute]="attribute"
									/>
								}
								@case (DAAType.Contacts) {
									<dunning-action-form-field-contacts [attribute]="attribute" />
								}
								@case (DAAType.AssignedOperator) {
									<dunning-action-form-field-assigned-operator [attribute]="attribute" />
								}
								@case (DAAType.NotifiedUsers) {
									<dunning-action-form-field-notified-users [attribute]="attribute" />
								}
							}
						}
					}

					<dunning-action-form-field-features />
				</div>

				<div class="overflow-auto">
					@if ((actionTypeSpec$ | async).showLinkedDocuments(action)) {
						<dunning-action-form-field-accounting />
					}

					@if (hasDunningClearanceLevel && !form.disabled) {
						<dunning-action-form-field-comment [field]="form.get('comment')" />
					}

				</div>

				@if (hasRequiredFields) { <div class="form-text" translate="Forms.RequiredFields"></div> }
			</div>
		</form>
	}
</div>
